/* ==============================================================
   AMIGO PROVISIONS — Collection toolbar filter dropdown (mobile)
   --------------------------------------------------------------
   Pairs with the .toolbar__filterwrap markup in
   sections/amigo-collection-grid.liquid. On mobile the filter chips
   + in-stock toggle live inside a panel that drops down when the
   "Filter" button is tapped; this toggles data-open and keeps
   aria-expanded in sync, and closes on Escape / outside click.

   On desktop the button is hidden and the panel renders inline (CSS),
   so the toggles here are harmless no-ops.
   ============================================================== */
(() => {
  const wraps = document.querySelectorAll('[data-filter-dropdown]');
  if (!wraps.length) return;

  const setOpen = (wrap, open) => {
    wrap.setAttribute('data-open', String(open));
    const btn = wrap.querySelector('.toolbar__filterbtn');
    if (btn) btn.setAttribute('aria-expanded', String(open));
  };

  wraps.forEach((wrap) => {
    const btn = wrap.querySelector('.toolbar__filterbtn');
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(wrap, wrap.getAttribute('data-open') !== 'true');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') wraps.forEach((wrap) => setOpen(wrap, false));
  });

  document.addEventListener('click', (e) => {
    wraps.forEach((wrap) => {
      if (!wrap.contains(e.target)) setOpen(wrap, false);
    });
  });
})();
